import { render, staticRenderFns } from "./VCostsInbox.vue?vue&type=template&id=2a5b7b54&"
import script from "./VCostsInbox.vue?vue&type=script&lang=js&"
export * from "./VCostsInbox.vue?vue&type=script&lang=js&"
import style0 from "./VCostsInbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports